import { API_URL as ENDPOINT } from "../config/env";

/**
 * Descarga el reporte de un proyecto (resumen de costos + flujo de efectivo).
 *
 * Se baja con fetch y no con window.open porque la ruta pide el token en el
 * header, y una ventana nueva no lo lleva.
 */
export async function ReporteProyectoDescargar(proyectoId, token) {
  const respuesta = await fetch(`${ENDPOINT}ReporteProyectoDescargar/${proyectoId}`, {
    headers: { Authorization: `${token}` },
  });

  if (!respuesta.ok) {
    let mensaje = "No se pudo generar el reporte";
    try {
      const error = await respuesta.json();
      mensaje = error.message || mensaje;
    } catch (e) {
      // La respuesta no era JSON: se queda el mensaje genérico.
    }
    throw new Error(mensaje);
  }

  const nombre = (respuesta.headers.get("content-disposition") || "")
    .split("filename=")
    .pop()
    .replace(/["';]/g, "")
    .trim();

  const blob = await respuesta.blob();
  const url = window.URL.createObjectURL(blob);
  const enlace = document.createElement("a");

  enlace.href = url;
  enlace.download = nombre || "reporte.xlsx";
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  window.URL.revokeObjectURL(url);
}
